import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// import { useWindowSize } from '@react-hook/window-size';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { useTheme } from '../../ThemeContext';

import {
  viewerPhotoDocumentsDeleteInit,
  viewerPhotoDocumentsDelete,
} from '../../actions/Viewer/ViewerActions';

import Modal from '../Modal';

import {
  Form,
  Wrapper,
  Header,
  Title,
  Content,
  Footer,
  Button,
  Box,
  Textbox,
  Text,
} from './PhotoDocumentsDelete.style';
// import { Breakpoints } from '../../assets/Variables.style';

const PhotoDocumentsDeleteInner = ({
  ids = [],
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const dispatch = useDispatch();
  const firebaseStore = useSelector((state) => state.firebase);
  const { profile } = firebaseStore;
  const isProfileCompany = profile.company && profile.company.id ? true : false;

  const viewerPhotoDocumentsDeleteStore = useSelector(
    (state) => state.viewerPhotoDocumentsDeleteStore
  );
  const {
    isLoading,
    isSuccess,
    isError,
    error,
  } = viewerPhotoDocumentsDeleteStore;

  const onSubmit = (e) => {
    e.preventDefault();
    if (isProfileCompany) {
      dispatch(viewerPhotoDocumentsDelete({ ids }));
    }
  };

  useEffect(() => {
    dispatch(viewerPhotoDocumentsDeleteInit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleProcess(isLoading ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSuccess, isError]);

  const renderSuccessPanel = () => {
    return (
      <Wrapper theme={theme.photoDocumentsDelete.wrapper}>
        <Header theme={theme.photoDocumentsDelete.header}>
          <Title theme={theme.photoDocumentsDelete.title}>
            {intl.formatMessage({
              id: 'DELETE_PHOTO_DOCUMENTS.SUCCESS',
            })}
          </Title>
        </Header>
        <Content>
          <Box>
            <Textbox center>
              <Text theme={theme.photoDocumentsDelete.text.default}>
                {intl.formatMessage({
                  id: `DELETE_PHOTO_DOCUMENTS.TEXT.THE_PHOTO_DOCUMENTS_HAVE_BEEN_SUCCESSFULLY_DELETED`,
                })}
              </Text>
            </Textbox>
          </Box>
        </Content>
        <Footer>
          <Button
            type='button'
            theme={theme.button.default}
            onClick={() => {
              handleClose();
            }}
          >
            {intl.formatMessage({ id: 'DELETE_PHOTO_DOCUMENTS.OK' })}
          </Button>
        </Footer>
      </Wrapper>
    );
  };

  return (
    <>
      {isSuccess ? (
        renderSuccessPanel()
      ) : (
        <Form onSubmit={onSubmit}>
          <Wrapper theme={theme.photoDocumentsDelete.wrapper}>
            <Header theme={theme.photoDocumentsDelete.header}>
              <Title theme={theme.photoDocumentsDelete.title}>
                {intl.formatMessage({
                  id: 'DELETE_PHOTO_DOCUMENTS.DELETE_PHOTO_DOCUMENTS',
                })}
              </Title>
            </Header>
            <Content>
              <Box>
                <Textbox center>
                  <Text theme={theme.photoDocumentsDelete.text.default}>
                    {intl.formatMessage({
                      id: `DELETE_PHOTO_DOCUMENTS.TEXT.ARE_YOU_SURE_WANT_TO_DELETE_PHOTO_DOCUMENTS`,
                    })}
                    <br />
                    {intl.formatMessage({
                      id: `DELETE_PHOTO_DOCUMENTS.TEXT.THIS_OPERATION_CANNOT_BE_UNDONE`,
                    })}
                  </Text>
                </Textbox>
              </Box>
            </Content>
            {isError ? (
              <Textbox>
                <Text theme={theme.photoDocumentsDelete.text.error}>
                  {intl.formatMessage({
                    id: `DELETE_PHOTO_DOCUMENTS.TEXT.ERROR.${error}`,
                    defaultMessage: error,
                  })}
                </Text>
              </Textbox>
            ) : (
              ''
            )}
            <Footer>
              <Button
                type='button'
                theme={theme.button.alt}
                disabled={isLoading}
                onClick={() => {
                  handleClose();
                }}
              >
                {intl.formatMessage({ id: 'DELETE_PHOTO_DOCUMENTS.CANCEL' })}
              </Button>
              <Button theme={theme.button.default} disabled={isLoading}>
                {isLoading
                  ? intl.formatMessage({
                      id: 'DELETE_PHOTO_DOCUMENTS.PLEASE_WAIT',
                    })
                  : intl.formatMessage({
                      id: `DELETE_PHOTO_DOCUMENTS.DELETE`,
                    })}
              </Button>
            </Footer>
          </Wrapper>
        </Form>
      )}
    </>
  );
};

const PhotoDocumentsDelete = ({
  ids = [],
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  // const [width] = useWindowSize();
  return (
    <Modal
      handleClose={handleClose}
      // fullscreen={width <= Breakpoints.md ? true : false}
    >
      <PhotoDocumentsDeleteInner
        ids={ids}
        handleClose={handleClose}
        handleProcess={handleProcess}
      />
    </Modal>
  );
};

PhotoDocumentsDeleteInner.propTypes = {
  ids: PropTypes.array,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

PhotoDocumentsDelete.propTypes = {
  ids: PropTypes.array,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

export default PhotoDocumentsDelete;
